define([
	"dojo/_base/declare",
	"SiteAdmin/GeneratePDF",
	"csi/locale",
	"csi/widget/MessageDialog"
], function(declare,GeneratePDF,locale,MessageDialog) {

	return declare(GeneratePDF, {

		_preAction: function() {
			const dataPackageUrl = this.getNode().SRLineItemPackage;
			const dataPackageNode = this.m_cache.getNode(dataPackageUrl);
			if(dataPackageNode && !dataPackageNode.UseCoverSheet && !dataPackageNode.DataSheets.length){
				this.displayErrorDialog({
					materialIcon: MessageDialog.ICON_WARNING,
					message: locale.resource("DPNoDataSheets_Error"),
					title: locale.resource("WARNING")
				});
			}else{
				return this.inherited(arguments);
			}
		},
		
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: initialize fields from user settings
			this.inherited(arguments);
			view.addDefaultValue("RefreshDataSheets", true);
			
			const srLocale = this.m_cache.getNode(this.getParent().Locale);
			const fd = this.getFormData();
			if(srLocale && fd) {
				fd.setFieldInitialValue("Locale", srLocale.$Name);
			}
		},

		postProcessSuccess: function() {
			// refresh data sheets view if necessary
			var	b = this.m_formData.getFieldValue("RefreshDataSheets");
			if (b) {
				var	view = this.widget.viewParent.getChildView("DataSheets");
				if (view) {
					view.refreshWidget(true);
				}
			}

			this.inherited(arguments);
		}
	});
});